import { useStore } from '../../store/store';
import './topbar.css';

export type TopbarProps = {
  history: { goBack: () => void };
  backRoute?: string;
  pageName: string;
};

const Topbar = (props: TopbarProps) => {
  const { setRedirect } = useStore();

  const goBack = () => {
    if (props.backRoute && props.backRoute !== '') {
      setRedirect(props.backRoute);
    } else {
      props.history.goBack();
    }
  };

  return (
    <div className="topbar">
      <div className="topbar__items">
        <span className="clickable topbar__item--arrow" onClick={goBack}>
          ←
        </span>
        <h2>{props.pageName}</h2>
      </div>
    </div>
  );
};

export default Topbar;
